var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.invitation
    ? _c(
        "div",
        {
          staticClass: "fixed z-50 pin overflow-auto bg-modal",
          class: _vm.active ? "block" : "hidden"
        },
        [
          _c(
            "div",
            { staticClass: "shadow max-w-sm mx-auto mt-24 px-4 md:px-0" },
            [
              _c("div", { staticClass: "bg-white rounded-t p-6" }, [
                _c(
                  "div",
                  { staticClass: "text-center text-grey-dark leading-normal" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("Are_you_sure_to_decline_this_appointment_")
                        ) +
                        "\n            "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex border-t items-center" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "block text-center bg-white rounded-bl w-1/2 border-r py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-black",
                    on: { click: _vm.close }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Cancel")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "block text-center bg-white rounded-br w-1/2 py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-blue",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.decline($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Yes_decline")) +
                        "\n            "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a1d8d58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a1d8d58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/DeclineInvitationModal.vue
// module id = 780
// module chunks = 1